import { render, staticRenderFns } from "./TopPerformance.vue?vue&type=template&id=2978f88c&"
import script from "./TopPerformance.vue?vue&type=script&lang=js&"
export * from "./TopPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports